import axios from "axios"
import { env } from "../constants"

/* Get */
export const get = data => {
    const uri = `${env.startpoint}home/web`
    return axios.post(uri, data).then(response => response).catch(data => data.response)
}

/* Book Members */
export const members = data => {
    const uri = `${env.startpoint}home/book-members`
    return axios.post(uri, data).then(response => response).catch(data => data.response)
}

/* Book Times */
export const worktimes = data => {
    const uri = `${env.startpoint}home/book-times`
    return axios.post(uri, data).then(response => response).catch(data => data.response)
}

/* Create */
export const create = (data) => {
    const uri = `${env.startpoint}booking/create-web`
    const headers = { headers: { Authorization: `Bearer ${''}`, 'Content-Type': 'multipart/form-data' } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* Check-phone */
export const checkPhone = data => {
    const uri = `${env.startpoint}booking/check-phone`
    const headers = { headers: { Authorization: `Bearer` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}